module.exports = __webpack_public_path__ + "static/media/Display_Admin_IMG-Mobile.9a0ee8dd.png";